import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { faFile, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@morressier/alembic';
import { ICreateTagFormData } from 'src/pages/Organization/Workspace/Settings/ManageTags/CreateTag';

type ITagDetail = ICreateTagFormData & {
  id?: string;
  journal?: {
    id: string;
    name: string;
    shortname: string;
  };
};

export const TagDetails = ({ tags }: { tags: ITagDetail }) => {
  const {
    name,
    description,
    tagCategory,
    tagColor,
    tagDescription,
    usage,
    journal
  } = tags;
  return (
    <Flex direction={'column'} maxW="min(800px, 90vw)" p={2}>
      <Box width={'fit-content'}>
        <Badge size="context" variant="neutral">
          <Flex gap={1} alignItems="top" color={'neutralSecondaryContent'}>
            <Box>
              <FontAwesomeIcon
                icon={usage === 'users' ? faUser : faFile}
                color={tagColor}
              />
            </Box>
            <Text
              textStyle="textContext"
              whiteSpace={'break-spaces'}
              overflowWrap="anywhere"
              minWidth={0}
            >
              {name}
            </Text>
          </Flex>
        </Badge>
      </Box>
      <Flex direction={'column'} gap={2} mt={2}>
        {usage === 'users' && (
          <Flex direction={'column'}>
            <Text textStyle={'headingLine'} fontSize={14}>
              Scope
            </Text>
            <Text textStyle={'textContext'}>
              {journal?.shortname ? journal.shortname.toUpperCase() : 'Global'}
            </Text>
          </Flex>
        )}
        <Flex direction={'column'}>
          <Text textStyle={'headingLine'} fontSize={14}>
            Tag description
          </Text>
          <Text textStyle={'textContext'}>{description}</Text>
        </Flex>
        {tagCategory && (
          <Flex direction={'column'}>
            <Text textStyle={'headingLine'} fontSize={14}>
              Tag category
            </Text>
            <Text textStyle={'textContext'}>{tagCategory}</Text>
          </Flex>
        )}
        {tagDescription && (
          <Flex direction={'column'}>
            <Text textStyle={'headingLine'} fontSize={14}>
              Tag category description
            </Text>
            <Text textStyle={'textContext'}>{tagDescription}</Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
interface TagDetailsPopoverProps {
  tagDetail: ITagDetail;
}

const TagDetailsPopover: React.FC<TagDetailsPopoverProps> = ({ tagDetail }) => {
  return (
    <Tooltip
      hasArrow
      key={tagDetail.id}
      borderRadius={4}
      placement="auto"
      background={'surfacePrimaryFill'}
      color={'neutralSecondaryContent'}
      label={<TagDetails tags={tagDetail} />}
    >
      <Box width={'fit-content'} maxW="100%">
        <Badge size="context" variant="neutral">
          <Flex gap={1} alignItems="center" color={'neutralSecondaryContent'}>
            <FontAwesomeIcon
              icon={tagDetail.usage === 'users' ? faUser : faFile}
              color={tagDetail.tagColor}
            />
            <Text textStyle="textContext" noOfLines={1} maxW="200px">
              {tagDetail.name}
            </Text>
          </Flex>
        </Badge>
      </Box>
    </Tooltip>
  );
};

export default TagDetailsPopover;
